export const getChatKey = (chat) => `${chat.chatId}_${chat.botId ?? 'no-bot'}`;
